import React from 'react';
import DatePicker from './DatePicker';
import { StandardTextFieldProps } from '@mui/material';
import { Dayjs } from 'dayjs';

export const Index = (props: DatePickerIndexProps) => {
  return <DatePicker {...props} />;
};

export interface DatePickerProps extends StandardTextFieldProps {
  dateValue: Dayjs | null;
  onDateChange: (date: Dayjs | null) => void;
  pickerType?: 'date' | 'dateTime';
  styleVariant?: 'standard' | 'outlined';
  minDate?: Dayjs;
  maxDate?: Dayjs;
  disablePast?: boolean;
  label?: string;
  disableUnderline?: boolean;
}

export interface DatePickerIndexProps extends DatePickerProps {
  pickerType: 'date' | 'dateTime';
}

export default Index;
